import { render } from "./SettingListPage.vue?vue&type=template&id=4f19e26e"
import script from "./SettingListPage.vue?vue&type=script&lang=js"
export * from "./SettingListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__